import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import Source from "../../../../items/Source";
import MiniLegend from "../../../../items/MiniLegend";

import {BarChart} from "d3plus-react";
import {numberWithCommas, calculateDomain} from "../../../../../helpers/formatters";


class LaborMarketSupply extends Component {

  constructor(props) {
    super();
    this.state = {
      config1: {},
      config2: {},
      config3: {},
      config4: {},
      config5: {},
      colors: []
    };
    this.createConfigs = this.createConfigs.bind(this);
  }

  componentDidMount() {
    this.createConfigs(this.props.clustersData, this.props.selectedCluster, 0);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.clustersData.length !== nextProps.clustersData.length) {
      this.createConfigs(nextProps.clustersData, nextProps.selectedCluster, 0);
    }
    if (
      this.props.selectedCluster.id !== nextProps.selectedCluster.id
    ) {
      this.createConfigs(nextProps.clustersData, nextProps.selectedCluster, 300);
    }
    if (
      this.state.config1 !== nextState.config1 ||
      this.state.config2 !== nextState.config2 ||
      this.state.config3 !== nextState.config3 ||
      this.state.config4 !== nextState.config4 ||
      this.state.config5 !== nextState.config5
    ) {
      return true;
    }
    return false;
  }

  createConfigs(clustersData, selectedCluster, delayMS) {
    const selectedClusterID = selectedCluster.id;
    const averageClusterID = 14;
    const clustersIds = [selectedClusterID, averageClusterID];

    const filteredData = clustersData.filter(cd => clustersIds.indexOf(cd.cluster_id) > -1);

    const colors = filteredData.map(d => ({color: d.color, label: d.cluster_name}));

    const varFormatters = [
      x => `${x.toFixed(1)}%`,
      x => `${x.toFixed(1)}`,
      x => `${x.toFixed(1)}`,
      x => `${x.toFixed(1)}%`,
      x => `${numberWithCommas(Math.round(x))}`,
    ];

    const longerNames = [
      "Working-age population growth",
      "Net migration rate",
      "Old-age dependency ratio",
      "Residents with tertiary education",
      "Average annual STEM graduate output"
    ];

    const fields = {
      'working_age_population_growth_2007_18_in_share': '<b>Working-age population change</b>, 2018, %',
      'net_migration_rate_2018': '<b>Net migration rate¹</b>, 2018',
      'old_age_dependency_ratio_2018': '<b>Old-age dependency ratio²</b>, 2018',
      'population_with_tertiary_education_2018_in_share': '<b>Residents with tertiary education</b>, 2018, %',
      'average_annual_stem_graduate_output_2013_2018': '<b>Average STEM graduates</b> 2018'
    };
    let longestStr = "";
    let xMaxes = [0, 0, 0, 0, 0];
    let xMins = [0, 0, 0, 0, 0];
    let dataSets = Object.keys(fields).map((f, idx) => {
      if (fields[f].length > longestStr) {
        longestStr = fields[f];
      }
      const finalData = [];
      let value;
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({cluster_id: fd.cluster_id, cluster_name: fd.cluster_name, property: fields[f], value: value, color: fd.color});
        xMaxes[idx] = xMaxes[idx] < value ? value : xMaxes[idx];
        xMins[idx] = xMins[idx] > value ? value : xMins[idx];
      });
      return finalData;
    });
    let vizHeight = 78;
    let configs = dataSets.map((dataSet, idx) => {
      let myDomain = calculateDomain(xMins[idx], xMaxes[idx]);
      const chartConfigTemplate = {
        data: dataSet,
        groupBy: "cluster_name",
        discrete: "y",
        discreteCutoff: 0,
        // we want bars to appear evenly sized, but only show legend once
        legend: false,
        //legendConfig: idx === 0 ? {select: `#${slideId}`} : {},
        height: vizHeight,
        y: "property",
        x: "value",
        tooltipConfig: {
          body: d => `<div>${longerNames[idx]}: ${varFormatters[idx](d.value)}</div>`
        },
        yConfig: {
          title: false,
          minSize: 200, //textWidth(longestStr) + 10,
          tickSize: 0
        },
        xConfig: {
          title: false,
          tickFormat: tick => `${varFormatters[idx](tick)}`,
          tickSize: 0,
          labels: myDomain.length > 0 ? [0] : [],
          domain: myDomain
        },
        shapeConfig: {
          Bar: {
            fill: d => d.color,
            duration: 0,
            label: (d) => (`${varFormatters[idx](d.value)}`)
          }
        },
        groupPadding: 0,
        barPadding: 2,
        legendTooltip: {
          body: "",
          footer: "",
        },
        on: {"click.legend": () => {}}
      };
      if (delayMS > 0) {
        setTimeout(() => {
          this.setState({[`config${idx + 1}`]: chartConfigTemplate, colors: colors});
        }, delayMS * (idx + 1));
      }
      return chartConfigTemplate;

    });
    if (delayMS === 0) {
      this.setState({
        config1: configs[0],
        config2: configs[1],
        config3: configs[2],
        config4: configs[3],
        config5: configs[4],
        colors: colors
      });
    }
  }

  render() {
    const {clustersData} = this.props;
    if (clustersData.length === 0) {
      return '';
    }
    const {config1, config2, config3, config4, config5, colors} = this.state;


    return (
      <CarouselItem title="Labor supply">
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <BarChart config={config1} />
          <BarChart config={config2} />
          <BarChart config={config3} />
          <BarChart config={config4} />
          <BarChart config={config5} />
          <Source text="1. Ratio of the population change per year (the difference between the population sizes on January 1 of two consecutive years) to the average population in that year. The value is expressed per 1,000 persons. 2018 data." />
          <Source text="2. Old-age-dependency ratio is the ratio between the number of persons aged 65 and over and the number of persons aged between 15 and 64. The value is expressed per 100 persons of working age (15-64)"/>
          <Source text="Source: Oxford Economics, Eurostat; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : [],
    selectedCluster: state.settings.map["Clusters"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborMarketSupply);
